import Lottie from "react-lottie";
import { assets } from "../../assets";
import { Modal } from "@mui/material";
import React from "react";

const sizes = {
  small: {
    height: 50,
    width: 50,
  },
  medium: {
    height: 100,
    width: 100,
  },
  large: {
    height: 200,
    width: 200,
  },
};

export const LoaderAnimationComponent = ({ open, fontSize = "large" }) => {
  const size = sizes[`${fontSize}`];
  return (
    <Modal open={open} hideBackdrop sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <React.Fragment>
        <Lottie isClickToPauseDisabled height={`${size.height}px`} width={`${size.width}px`} options={{ animationData: assets.animation.cleaning }} style={{ position: "relative" }}></Lottie>
        <Lottie
          isClickToPauseDisabled
          height={`${size.height * 2.5}px`}
          width={`${size.width * 2.5}px`}
          options={{ animationData: assets.animation.loading }}
          style={{ position: "absolute" }}
        ></Lottie>
      </React.Fragment>
    </Modal>
  );
};
